import styles from "./list.module.css";
import { Button, Divider, Drawer, Menu, MenuItem, Tooltip, useMediaQuery } from "@mui/material";
import { Edit, Eye, Mail, MessageSquare, MoreVertical, Printer, X } from "react-feather";
import { useNavigate } from "react-router-dom";
import { authData } from "../../../components/GetAuth";
import { useState } from "react";

const ActionListItem = ({ item, setInvoiceMail, setInvoiceMailId, setSendInvoiceModalOpen, printBooking, setCancelId, setCancelModalOpen, setViewStr, setViewId, setViewModalOpen, setViewDeliveryModalOpen }) => {
    const navigate = useNavigate();
    const auth = authData();
    const isMobile = useMediaQuery("(max-width:768px)");
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const isCancelled = parseInt(item?.status) === -1;
    const isDeliverred = parseInt(item?.status) === 7;
    const canManage = auth?.user_type === 1 || auth?.user_type === 2 || auth?.permissions?.indexOf('bookings:update') > -1;
    const canInvoice = parseInt(item?.status) >= 2;

    const close = () => setAnchorEl(null);

    const actions = [
        {
            key: "view",
            label: "View Details",
            icon: <Eye size={16} />,
            iconClass: styles.IconView,
            show: true,
            onClick: () => {
                if (item?.is_delivery === 1) {
                    setViewDeliveryModalOpen(true);
                } else {
                    setViewModalOpen(true);
                }
                setViewId(item?.id);
                setViewStr(item?.booking_id);
            },
        },
        {
            key: "edit",
            label: "Edit Booking",
            icon: <Edit size={16} />,
            iconClass: styles.IconEdit,
            show: canManage,
            disabled: isCancelled || isDeliverred,
            onClick: () => navigate(item?.is_delivery === 1 ? "/booking/edit-delivery-booking/" + item?.id : "/booking/edit-booking/" + item?.id),
        },
        {
            key: "print",
            label: "Print Booking",
            icon: <Printer size={16} />,
            iconClass: styles.IconPrint,
            show: true,
            onClick: () => printBooking(item?.id),
        },
        {
            key: "enquiry",
            label: "Enquiry Your Order",
            icon: <MessageSquare size={16} />,
            iconClass: styles.IconMessage,
            show: true,
            onClick: () => navigate("/booking/enquery/" + item?.booking_id),
        },
        {
            key: "invoice",
            label: "Send Invoice",
            icon: <Mail size={16} />,
            iconClass: styles.IconMail,
            show: true,
            disabled: !canInvoice,
            onClick: () => {
                setSendInvoiceModalOpen(true);
                setInvoiceMailId(item?.id);
                setInvoiceMail(item?.customer_email);
            },
        },
    ];

    const cancelAction = {
        key: "cancel",
        label: "Cancel Booking",
        icon: <X size={16} />,
        iconClass: styles.IconCancel,
        show: canManage,
        onClick: () => {
            setCancelModalOpen(true);
            setCancelId(item?.id);
        },
    };

    const runAction = (action) => {
        close();
        action.onClick();
    };

    return (<>
        <Tooltip title="More actions">
            <Button
                variant="outlined"
                size="small"
                className={styles.ActionTrigger}
                onClick={(e) => setAnchorEl(e.currentTarget)}
            >
                <MoreVertical size={18} />
            </Button>
        </Tooltip>

        {!isMobile && (
            <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={close}
                transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
                classes={{ paper: styles.ActionMenuPaper }}
            >
                {actions.filter((a) => a.show).map((a) => (
                    <MenuItem key={a.key} className={styles.ActionMenu} disabled={a.disabled} onClick={() => runAction(a)}>
                        <span className={`${styles.ActionIcon} ${a.iconClass}`}>{a.icon}</span>
                        {a.label}
                    </MenuItem>
                ))}

                {cancelAction.show && <Divider sx={{ my: 0.5 }} />}
                {cancelAction.show && (
                    <MenuItem className={`${styles.ActionMenu} ${styles.ActionMenuDanger}`} onClick={() => runAction(cancelAction)}>
                        <span className={`${styles.ActionIcon} ${cancelAction.iconClass}`}>{cancelAction.icon}</span>
                        {cancelAction.label}
                    </MenuItem>
                )}
            </Menu>
        )}

        {isMobile && (
            <Drawer
                anchor="bottom"
                open={open}
                onClose={close}
                classes={{ paper: styles.SheetPaper }}
            >
                <div className={styles.SheetHandle} />
                <div className={styles.SheetHeader}>
                    <div className={styles.SheetTitle}>Booking #{item?.booking_id}</div>
                    <div className={styles.SheetSubTitle}>Choose an action</div>
                </div>

                <div className={styles.SheetList}>
                    {actions.filter((a) => a.show).map((a) => (
                        <MenuItem key={a.key} className={styles.SheetItem} disabled={a.disabled} onClick={() => runAction(a)}>
                            <span className={`${styles.ActionIcon} ${a.iconClass}`}>{a.icon}</span>
                            {a.label}
                        </MenuItem>
                    ))}

                    {cancelAction.show && <div className={styles.SheetDivider} />}
                    {cancelAction.show && (
                        <MenuItem className={`${styles.SheetItem} ${styles.SheetItemDanger}`} onClick={() => runAction(cancelAction)}>
                            <span className={`${styles.ActionIcon} ${cancelAction.iconClass}`}>{cancelAction.icon}</span>
                            {cancelAction.label}
                        </MenuItem>
                    )}
                </div>
            </Drawer>
        )}
    </>)
}

export default ActionListItem;